import { render } from "./ViewUserComponent.vue?vue&type=template&id=29945a30&scoped=true&lang=html"
import script from "./ViewUserComponent.vue?vue&type=script&lang=js"
export * from "./ViewUserComponent.vue?vue&type=script&lang=js"

import "./ViewUserComponent.vue?vue&type=style&index=0&id=29945a30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29945a30"]])

export default __exports__